(ns scittle.kixi-stats
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [kixi.stats.core]
    [kixi.stats.distribution]
    [kixi.stats.test]))

;; Plugin: kixi-stats
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::kixi-stats
   {:namespaces
   {'kixi.stats.core (sci/copy-ns kixi.stats.core (sci/create-ns 'kixi.stats.core nil))
    'kixi.stats.distribution (sci/copy-ns kixi.stats.distribution (sci/create-ns 'kixi.stats.distribution nil))
    'kixi.stats.test (sci/copy-ns kixi.stats.test (sci/create-ns 'kixi.stats.test nil))}}
   ))
